import { resolverPortalDeLaUrl } from './tenant-basename';

/**
 * Una dirección de la MISMA empresa para un `<a href>`, con su `/<slug>` adelante.
 *
 * 🔴 `<a href="/pricing-rules">` a secas pierde la empresa: el router lee el
 * primer segmento como el slug (`tenant-basename.ts`), y «pricing-rules» pasaría
 * por una empresa. Dentro de un componente con router, `<Link to>` ya antepone el
 * basename; esto es para los lugares que se prueban sin router o que arman un
 * enlace fuera de React Router. Usa la misma regla que `AppRouter`.
 */
export function hrefDeLaEmpresa(ruta: string, pathname: string = window.location.pathname): string {
  const portal = resolverPortalDeLaUrl(pathname);
  return portal.tipo === 'empresa' ? `/${portal.slug}${ruta}` : ruta;
}
